export const ORDER_DETAILS_FIELD_KEY_PREFIX = 'order-details:';

export const toOrderDetailsTargetCellKey = (fieldName: string) =>
  `${ORDER_DETAILS_FIELD_KEY_PREFIX}${fieldName}`;

export const parseOrderDetailsTargetCellKey = (targetCellKey: string) => {
  if (!targetCellKey.startsWith(ORDER_DETAILS_FIELD_KEY_PREFIX)) {
    return undefined;
  }
  return targetCellKey.slice(ORDER_DETAILS_FIELD_KEY_PREFIX.length);
};

export const scrollOrderDetailsFieldIntoView = (fieldName: string) => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      const container = document.querySelector(`[data-order-details-field="${fieldName}"]`);
      if (container instanceof HTMLElement) {
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });
};

export const focusOrderDetailsField = (fieldName: string) => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      const container = document.querySelector(`[data-order-details-field="${fieldName}"]`);
      if (!(container instanceof HTMLElement)) {
        return;
      }
      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const focusable = container.querySelector<HTMLElement>(
        'input, textarea, button, [role="combobox"]',
      );
      if (focusable) {
        focusable.focus();
        if (focusable.tagName === 'BUTTON') {
          focusable.click();
        }
        return;
      }
      container.focus();
    });
  });
};
